export default {
  headerContent: {
    title: 'Quick Sigorta Nakliyat Sigortası Fiyatları',
    slogan: "Nakliyat Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'NAKLİYAT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Quick Sigorta Nakliyat (Emtea) Sigortası',
    description: {
      title: 'Quick Sigorta Nakliyat (Emtea) Sigortası Nedir? ',
      content: [
        'Nakliyat sigortası, emteanın uygun taşıma araçları ile taşınması esnasında meydana gelebilecek risklere karşı koruma sağlamaktadır. ',
        'Quick Sigorta nakliyat sigortası oluşan hasarlar sonucunda ortaya çıkacak finansal riskleri koruma altına alarak sermayenize güvence sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Quick Sigorta Nakliyat Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph: 'Nakliyat sigortasında 3 adet teminat bulunmaktadır.',
          subList: null
        },
        {
          paragraph: 'Bu teminatlar;',
          subList: ['Tam Ziya', 'Dar Teminat', 'Geniş Teminat']
        },
        {
          paragraph: '<strong>Tam Ziya Teminatı Nedir?</strong>',
          subList: null
        },
        {
          paragraph:
            'Taşıma aracı ve malın tüm değerini kaybedecek derece hasar görmesini halinde karşılık verilen teminattır.',
          subList: null
        },
        {
          paragraph: '<strong>Dar Teminat Nedir?</strong>',
          subList: null
        },
        {
          paragraph:
            'Dar teminat malın ve taşıma aracının uğrayacağı kısmı hasarlar sonucu çıkan masrafları teminat altına almaktadır.',
          subList: null
        },
        {
          paragraph: '<strong>Geniş Teminat Nedir?</strong>',
          subList: null
        },
        {
          paragraph:
            'Geniş teminat ile taşınan malda taşıma esnasında oluşacak kaza veya olay neticesindeki maddi kayıplara karşı güvence sağlamaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Nakliyat Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: '<strong>Nakliyat Sigortası</strong>',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: '<strong>Nakliyat Sigortası</strong>',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: '<strong>Nakliyat Sigortası</strong>',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: '<strong>Nakliyat Sigortası</strong>',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Quick Sigorta Nakliyat Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
